export const EMPTY_CONFIG_MAP = {
  // 图片：一个文件夹，里面插了一张纸 —— 无文件
  file: {
    img: 'https://img.alicdn.com/imgextra/i3/O1CN01xMsEkn1OVgWBoGh2n_!!6000000001711-2-tps-432-432.png',
    darkImg: 'https://img.alicdn.com/imgextra/i3/O1CN01llekqX1VGIWJT1dHy_!!6000000002625-2-tps-432-432.png'
  },
  // 图片：一个钩子，吊着一个纸袋子 —— 建设中
  building: {
    img: 'https://img.alicdn.com/imgextra/i2/O1CN01NZbihu29QuKNEiVft_!!6000000008063-2-tps-432-432.png',
    darkImg: 'https://img.alicdn.com/imgextra/i1/O1CN01zCSgFM1fUAfw7YBND_!!6000000004009-2-tps-432-432.png'
  },
  // 图片：一个人，头是个圆，身体是个半圆 —— 无成员
  member: {
    img: 'https://img.alicdn.com/imgextra/i4/O1CN01Dzllww1dkXbJjiuh1_!!6000000003774-2-tps-432-432.png',
    darkImg: 'https://img.alicdn.com/imgextra/i4/O1CN01s7QIP628KfJXEsm5r_!!6000000007914-2-tps-432-432.png'
  },
  // 图片：一把锁，锁上面有个钥匙孔 —— 无权限
  permission: {
    img: 'https://img.alicdn.com/imgextra/i4/O1CN016tNInE1Ve778LdtU4_!!6000000002677-2-tps-432-432.png',
    darkImg: 'https://img.alicdn.com/imgextra/i3/O1CN017OIEHt1OBX5go1vuO_!!6000000001667-2-tps-432-432.png'
  },
  // 图片：一个有圆角的五角星 —— 无收藏
  star: {
    img: 'https://img.alicdn.com/imgextra/i3/O1CN01pO2cQn1MuIZO9w94v_!!6000000001494-2-tps-432-432.png',
    darkImg: 'https://img.alicdn.com/imgextra/i2/O1CN01R6LRMG1OEHSuIquBO_!!6000000001673-2-tps-432-432.png'
  },
  // 图片：Wifi 没信号 —— 页面异常
  exception: {
    img: 'https://img.alicdn.com/imgextra/i3/O1CN01N44yQ51zTWQpqVBby_!!6000000006715-2-tps-432-432.png',
    darkImg: 'https://img.alicdn.com/imgextra/i3/O1CN019aJ4qX1KCfblhhUV8_!!6000000001128-2-tps-432-432.png'
  },
  // 图片：Wifi 没信号 —— 网络错误
  'network-error': {
    img: 'https://img.alicdn.com/imgextra/i3/O1CN01N44yQ51zTWQpqVBby_!!6000000006715-2-tps-432-432.png',
    darkImg: 'https://img.alicdn.com/imgextra/i3/O1CN019aJ4qX1KCfblhhUV8_!!6000000001128-2-tps-432-432.png'
  },
  // 图片：两个对话框，深色的里面有感叹号 —— 资源未找到
  'not-found': {
    img: 'https://img.alicdn.com/imgextra/i4/O1CN01zQNZxG1uQhuyFlBYc_!!6000000006032-2-tps-432-432.png',
    darkImg: 'https://img.alicdn.com/imgextra/i2/O1CN01Dfo2yX1MuIZYDX59O_!!6000000001494-2-tps-432-432.png'
  },
  // 图片：两个对话框，深色的里面有感叹号 —— 数据获取失败
  'fetch-error': {
    img: 'https://img.alicdn.com/imgextra/i4/O1CN01zQNZxG1uQhuyFlBYc_!!6000000006032-2-tps-432-432.png',
    darkImg: 'https://img.alicdn.com/imgextra/i2/O1CN01Dfo2yX1MuIZYDX59O_!!6000000001494-2-tps-432-432.png'
  },
  // 图片：一个浏览器，正中间是个禁止符号 —— 无浏览
  browser: {
    img: 'https://img.alicdn.com/imgextra/i3/O1CN01j42Nf11uo47L4rRzO_!!6000000006083-2-tps-432-432.png',
    darkImg: 'https://img.alicdn.com/imgextra/i2/O1CN01kFgouw1c7K4Se6WSf_!!6000000003553-2-tps-432-432.png'
  },
  // 图片：一个放大镜 —— 无结果
  search: {
    img: 'https://img.alicdn.com/imgextra/i2/O1CN01fL6uPg1KHFZR63X8Q_!!6000000001138-2-tps-432-432.png',
    darkImg: 'https://img.alicdn.com/imgextra/i3/O1CN01oFs85T1NDXCru7AIe_!!6000000001536-2-tps-432-432.png'
  },
  // 图片：一个盒子，里面装了一个闪电 —— 无内容
  box: {
    img: 'https://img.alicdn.com/imgextra/i2/O1CN01nPN94H1s8j8cRhG3e_!!6000000005722-2-tps-432-432.png',
    darkImg: 'https://img.alicdn.com/imgextra/i4/O1CN014OnL981wvVmo3bTt8_!!6000000006370-2-tps-432-432.png'
  },
  // 图片：一个人头，四周有文件夹和打开的书籍  —— 未绑定知识问答机器人
  'bind-robot': {
    img: 'https://img.alicdn.com/imgextra/i3/O1CN01WnDYlu1jT2AvoMEYM_!!6000000004548-2-tps-480-477.png',
    darkImg: 'https://img.alicdn.com/imgextra/i3/O1CN01WnDYlu1jT2AvoMEYM_!!6000000004548-2-tps-480-477.png'
  },
  // 一个人头 被一个文件夹和两个小球体做圆周运动
  'public-unable': {
    img: 'https://img.alicdn.com/imgextra/i3/O1CN01GYjbm81YcgeVNUJEw_!!6000000003080-2-tps-541-541.png',
    darkImg: 'https://img.alicdn.com/imgextra/i2/O1CN01UDHPsr1IoZ6oyrbWo_!!6000000000940-2-tps-541-541.png'
  }
};

// CSS 变量名会被压缩为 dash-case, 转小写以避免名称不匹配
export const getImgCSSVarName = type => "--portal-empty-img-" + type.toLowerCase();
const createStyleVar = () => {
  const lightImgsVar = {};
  const darkImgsVar = {};
  Object.entries(EMPTY_CONFIG_MAP).forEach(_ref => {
    let [k, v] = _ref;
    lightImgsVar[getImgCSSVarName(k)] = "url(" + v.img + ")";
    darkImgsVar[getImgCSSVarName(k)] = "url(" + v.darkImg + ")";
  });
  return {
    lightImgsVar,
    darkImgsVar
  };
};
const {
  lightImgsVar,
  darkImgsVar
} = createStyleVar();
export { lightImgsVar, darkImgsVar };
//# sourceMappingURL=helper.js.map